import { store } from "../../store";
import api from "../endpoints";
import http from "../httpService";
import { json_facet } from "./AdvancedSeach.api";

export const fq__resource_type = "( 1 OR 2 OR 3 OR 4 OR 8 OR 24 )";
export const staticData = {
  ...json_facet,
  // inventor:{"type":"terms","field":"inventor","limit":100},
  authors_tk: { type: "terms", field: "authors_tk", limit: 100 },
  primary_publisher_country: {
    type: "terms",
    field: "primary_publisher_country",
    limit: 100,
  },
  filter_metrix: { type: "terms", field: "filter_metrix", limit: 100 },
  journal_name: { type: "terms", field: "journal_name", limit: 100 },
  guide_name_tk: { type: "terms", field: "guide_name_tk", limit: 100 },
  speakers: { type: "terms", field: "speakers", limit: 100 },
  researcher_tk: { type: "terms", field: "researcher_tk", limit: 100 },
  openaccess_type: {
    type: "terms",
    field: "openaccess_type",
    limit: 100,
  },
  author_address: { type: "terms", field: "author_address", limit: 100 },
  author_country_name: {
    type: "terms",
    field: "author_country_name",
    limit: 100,
  },
  is_retracted: {
    type: "terms",
    field: "is_retracted",
    limit: 100,
  },
  has_datasets: {
    type: "terms",
    field: "has_datasets",
    limit: 100,
  },
  pubmed_article: {
    type: "terms",
    field: "pubmed_article",
    limit: 100,
  },
  is_onos_resource: {
    type: "terms",
    field: "is_onos_resource",
    limit: 100,
  },
};

export const getJsonFacets = (dataTypes: any) => {
  let jsonFacets = {
    ...json_facet,
    primary_publisher_country: {
      type: "terms",
      field: "primary_publisher_country",
      limit: 100,
    },
    openaccess_type: { type: "terms", field: "openaccess_type", limit: 100 },
    author_address: { type: "terms", field: "author_address", limit: 100 },
    author_country_name: {
      type: "terms",
      field: "author_country_name",
      limit: 100,
    },
  };

  // Add additional facets based on dataTypes
  if (dataTypes.includes(25)) {
    Object.assign(jsonFacets, {
      inventor: { type: "terms", field: "inventor", limit: 100 },
    });
  }
  if (
    dataTypes.includes(6) ||
    dataTypes.includes(12) ||
    dataTypes.includes(1) ||
    dataTypes.includes(3)
  ) {
    Object.assign(jsonFacets, {
      authors_tk: { type: "terms", field: "authors_tk", limit: 100 },
    });
  }
  if (dataTypes.includes(1)) {
    Object.assign(jsonFacets, {
      filter_metrix: { type: "terms", field: "filter_metrix", limit: 100 },
    });
    Object.assign(jsonFacets, {
      journal_name: { type: "terms", field: "journal_name", limit: 100 },
    });
    Object.assign(jsonFacets, {
      pubmed_article: { type: "terms", field: "pubmed_article", limit: 100 },
    });
    Object.assign(jsonFacets, {
      is_onos_resource: {
        type: "terms",
        field: "is_onos_resource",
        limit: 100,
      },
    });
  }
  if (dataTypes.includes(4)) {
    Object.assign(jsonFacets, {
      guide_name_tk: { type: "terms", field: "guide_name_tk", limit: 100 },
    });
    Object.assign(jsonFacets, {
      researcher_tk: { type: "terms", field: "researcher_tk", limit: 100 },
    });
  }
  if (dataTypes.includes(8)) {
    Object.assign(jsonFacets, {
      speakers: { type: "terms", field: "speakers", limit: 100 },
    });
  }
  if (dataTypes.includes(1) || dataTypes.includes(3)) {
    Object.assign(jsonFacets, {
      is_retracted: { type: "terms", field: "is_retracted", limit: 100 },
    });
  }
  if (dataTypes.includes(1) || dataTypes.includes(6)) {
    Object.assign(jsonFacets, {
      has_datasets: { type: "terms", field: "has_datasets", limit: 100 },
    });
  }

  return jsonFacets;
};

export const staticSubjectFacetData = {
  subjects_name_l3: {
    type: "terms",
    field: "subjects_name_l3",
    limit: 100,
  },
};

export const staticMeshKeywordFacetData = {
  mesh_keywords: {
    type: "terms",
    field: "mesh_keywords",
    limit: 100,
  },
};

export const staticAuthorFacetData = {
  authors_tk: { type: "terms", field: "authors_tk", limit: 100 },
  guide_name_tk: { type: "terms", field: "guide_name_tk", limit: 100 },
  speakers: { type: "terms", field: "speakers", limit: 100 },
  researcher_tk: { type: "terms", field: "researcher_tk", limit: 100 },
  author_address: { type: "terms", field: "author_address", limit: 100 },
  author_country_name: {
    type: "terms",
    field: "author_country_name",
    limit: 100,
  },
};

export const staticFacetData = {
  Collections_OpenAccess: {
    type: "query",
    q: "(fulltext_ACL:0 OR ishybridopenaccess:true)",
  },
  data_type: { type: "terms", field: "data_type", limit: 30 },
  yearfrom: {
    type: "terms",
    field: "yearfrom",
    limit: 100,
    sort: "index desc",
  },
  publisher_name: { type: "terms", field: "publisher_name", limit: 100 },
  // inventor:{"type":"terms","field":"inventor","limit":100},
  primary_publisher_country: {
    type: "terms",
    field: "primary_publisher_country",
    limit: 100,
  },
  filter_metrix: { type: "terms", field: "filter_metrix", limit: 100 },
  journal_name: { type: "terms", field: "journal_name", limit: 100 },
  openaccess_type: {
    type: "terms",
    field: "openaccess_type",
    limit: 100,
  },
  is_retracted: {
    type: "terms",
    field: "is_retracted",
    limit: 100,
  },
  has_datasets: {
    type: "terms",
    field: "has_datasets",
    limit: 100,
  },
  pubmed_article: {
    type: "terms",
    field: "pubmed_article",
    limit: 100,
  },
  is_onos_resource: {
    type: "terms",
    field: "is_onos_resource",
    limit: 100,
  },
  resource_source_index: {
    type: "terms",
    field: "resource_source_index",
    limit: 20,
  },
};

export async function basicSearch(query: any) {
  const myLibraryFilter = sessionStorage.getItem("my_library_filter");
  const consortiaFilter = sessionStorage.getItem("consortia_filter");
  const facetData = { ...staticData };
  // const data = store.getState().searchReducer.dataType;
  // const facetData = getJsonFacets(data)

  if (myLibraryFilter) {
    Object.assign(facetData, {
      Collections_LibrarySubscribed: { type: "query", q: myLibraryFilter },
    });
  }
  if (consortiaFilter) {
    Object.assign(facetData, {
      Collections_ConsotiaSubscribed: { type: "query", q: consortiaFilter },
    });
  }
  try {
    const { data: response } = await http.get(
      `/api/indexing/solr/articlecore2?rows=20&fq__active_flag=true&json_facet=${JSON.stringify(
        facetData,
      )}&${query}`,
    );

    return response.data;
  } catch (error) {
    console.log("Couldnt Fetch Search Results: ", error);
    throw error;
  }
}

//No Default Resource Type
export async function basicSearchMain(query: any) {
  const myLibraryFilter = sessionStorage.getItem("my_library_filter");
  const consortiaFilter = sessionStorage.getItem("consortia_filter");
  const facetData = { ...staticData };
  // const data = store.getState().searchReducer.dataType;
  // const facetData = getJsonFacets(data)

  if (myLibraryFilter) {
    Object.assign(facetData, {
      Collections_LibrarySubscribed: { type: "query", q: myLibraryFilter },
    });
  }

  if (consortiaFilter) {
    Object.assign(facetData, {
      Collections_ConsotiaSubscribed: { type: "query", q: consortiaFilter },
    });
  }
  try {
    const { data: response } = await http.get(
      `/api/indexing/solr/articlecore2?rows=20&fq__active_flag=true&json_facet=${JSON.stringify(
        facetData,
      )}&${query}`,
    );

    return response.data;
  } catch (error) {
    console.log("Couldnt Fetch Search Results: ", error);
    throw error;
  }
}

export async function basicSearchQuery(query: any) {
  const myLibraryFilter = sessionStorage.getItem("my_library_filter");
  const consortiaFilter = sessionStorage.getItem("consortia_filter");
  //const facetData = {...staticData}
  // const data = store.getState().searchReducer.dataType;
  // const facetData = getJsonFacets(data)

  // if(myLibraryFilter) {
  //   Object.assign(facetData, {Collections_LibrarySubscribed : {type: "query", q: myLibraryFilter}});
  // }

  // if(consortiaFilter) {
  //   Object.assign(facetData, {Collections_ConsotiaSubscribed : {type: "query", q: consortiaFilter}});
  // }
  try {
    // const { data: response } = await http.get(
    //   `/api/indexing/solr/articlecore2?rows=20&fq__active_flag=true&json_facet=${JSON.stringify(
    //     facetData
    //   )}&${query}`
    // );

    const { data: response } = await http.get(
      `/api/indexing/solr/articlecore2?rows=20&fq__active_flag=true&${query}`,
    );

    return response.data;
  } catch (error) {
    console.log("Couldnt Fetch Search Results: ", error);
    throw error;
  }
}

export async function subjectJsonFacetQuery(query: any) {
  const myLibraryFilter = sessionStorage.getItem("my_library_filter");
  const consortiaFilter = sessionStorage.getItem("consortia_filter");
  const facetData = { ...staticSubjectFacetData };
  // const data = store.getState().searchReducer.dataType;
  // const facetData = getJsonFacets(data)

  // if(myLibraryFilter) {
  //   Object.assign(facetData, {Collections_LibrarySubscribed : {type: "query", q: myLibraryFilter}});
  // }

  // if(consortiaFilter) {
  //   Object.assign(facetData, {Collections_ConsotiaSubscribed : {type: "query", q: consortiaFilter}});
  // }
  try {
    const { data: response } = await http.get(
      `/api/indexing/solr/articlecore2?rows=20&fq__active_flag=true&json_facet=${JSON.stringify(
        facetData,
      )}&${query}`,
    );

    return response.data;
  } catch (error) {
    console.log("Couldnt Fetch Search Results: ", error);
    throw error;
  }
}

export async function basicAISearchQuery(query: string, newSearch = false) {
  try {
    const { data } = await http.get(
      `/api/indexing/solr/articlecore2?rows=20&fq__active_flag=true&${query}`,
    );

    const response = data?.data;

    return response;
  } catch (error) {
    console.error("Couldn't Fetch Search Results:", error);
    throw error;
  }
}

export async function authorJsonFacetQuery(query: any) {
  const myLibraryFilter = sessionStorage.getItem("my_library_filter");
  const consortiaFilter = sessionStorage.getItem("consortia_filter");
  const facetData = { ...staticAuthorFacetData };
  // const data = store.getState().searchReducer.dataType;
  // const facetData = getJsonFacets(data)

  // if(myLibraryFilter) {
  //   Object.assign(facetData, {Collections_LibrarySubscribed : {type: "query", q: myLibraryFilter}});
  // }

  // if(consortiaFilter) {
  //   Object.assign(facetData, {Collections_ConsotiaSubscribed : {type: "query", q: consortiaFilter}});
  // }
  try {
    const { data: response } = await http.get(
      `/api/indexing/solr/articlecore2?rows=20&fq__active_flag=true&json_facet=${JSON.stringify(
        facetData,
      )}&${query}`,
    );

    return response.data;
  } catch (error) {
    console.log("Couldnt Fetch Search Results: ", error);
    throw error;
  }
}

export async function jsonFacetQuery(query: any) {
  const myLibraryFilter = sessionStorage.getItem("my_library_filter");
  const consortiaFilter = sessionStorage.getItem("consortia_filter");
  const facetData = { ...staticFacetData };
  // const data = store.getState().searchReducer.dataType;
  // const facetData = getJsonFacets(data)

  if (myLibraryFilter) {
    Object.assign(facetData, {
      Collections_LibrarySubscribed: { type: "query", q: myLibraryFilter },
    });
  }

  if (consortiaFilter) {
    Object.assign(facetData, {
      Collections_ConsotiaSubscribed: { type: "query", q: consortiaFilter },
    });
  }
  try {
    const { data: response } = await http.get(
      `/api/indexing/solr/articlecore2?rows=20&fq__active_flag=true&json_facet=${JSON.stringify(
        facetData,
      )}&${query}`,
    );

    return response.data;
  } catch (error) {
    console.log("Couldnt Fetch Search Results: ", error);
    throw error;
  }
}

export async function meshKeywordJsonFacetQuery(query: any) {
  const myLibraryFilter = sessionStorage.getItem("my_library_filter");
  const consortiaFilter = sessionStorage.getItem("consortia_filter");
  const facetData = { ...staticMeshKeywordFacetData };
  // const data = store.getState().searchReducer.dataType;
  // const facetData = getJsonFacets(data)

  // if(myLibraryFilter) {
  //   Object.assign(facetData, {Collections_LibrarySubscribed : {type: "query", q: myLibraryFilter}});
  // }

  // if(consortiaFilter) {
  //   Object.assign(facetData, {Collections_ConsotiaSubscribed : {type: "query", q: consortiaFilter}});
  // }
  try {
    const { data: response } = await http.get(
      `/api/indexing/solr/articlecore2?rows=20&fq__active_flag=true&json_facet=${JSON.stringify(
        facetData,
      )}&${query}`,
    );

    return response.data;
  } catch (error) {
    console.log("Couldnt Fetch Search Results: ", error);
    throw error;
  }
}

export async function fetchMeshKeywordsData(query: string[]) {
  try {
    const meshKeywordsParam = encodeURIComponent(JSON.stringify(query));
    const { data: response } = await http.get(
      `/api/mesh_keywords_expansion/?mesh_keywords=${meshKeywordsParam}`,
    );

    return response.data;
  } catch (error) {
    console.log("Couldnt Fetch Search Count: ", error);
    throw error;
  }
}

export async function basicSearchForCounts(query: any) {
  try {
    const { data: response } = await http.get(
      `/api/indexing/solr/articlecore2?rows=20&fq__active_flag=true&${query}`,
    );

    return response.data;
  } catch (error) {
    console.log("Couldnt Fetch Search Count: ", error);
    throw error;
  }
}

export async function getAbstractStatus(query: string) {
  try {
    const { data: response } = await http.get(
      `/api/article_abstract_display_status/article_abstract_display_status${query}`,
    );

    return response.data;
  } catch (error) {
    console.log("Couldnt Fetch Abstract Status: ", error);
    throw error;
  }
}

export async function basicSearchAuthorEmail(customerId: any) {
  try {
    const { data: response } = await http.get(
      `/api/get_authoremail_id/get_authoremail_id?article_id=${customerId}`,
    );

    return response.data;
  } catch (error) {
    console.log("Couldnt Fetch Author email data: ", error);
    throw error;
  }
}
export async function dSpaceSearchQuery(query: any) {
  try {
    const { data: response } = await http.get(
      `/api/dspace_integration_jgate/?${query}`,
    );

    return response.data;
  } catch (error) {
    console.log("Couldnt Fetch Author email data: ", error);
    throw error;
  }
}

export async function getDataSetDetails(id: any) {
  try {
    const response = await http.get(
      `/api/get_dataset_link_list/get_dataset_link_list?articleid=${id}`,
    );

    return response?.data?.data[0][0];
  } catch (error) {
    console.log(error);
  }
}

export const getFulltextPDFUrl = (
  params: Record<string, string | number | boolean>,
): string => {
  const queryString = new URLSearchParams(
    Object.fromEntries(Object.entries(params).map(([k, v]) => [k, String(v)])),
  ).toString();

  return `${api.baseApi}/api/get_fulltext_url?${queryString}`;
};

export function handleFulltextPDFLink(data: any) {
  const fullTextData = {
    resource_type: data?.resource_type,
    resourcemaster_id: data?.resourcemaster_id,
    publisher_id: data?.publisher_id?.[0],
    article_id: data?.article_id,
  };

  const url = getFulltextPDFUrl(fullTextData);
  window.open(url, "_blank");
}

interface GetAISummaryParams {
  userQuery: string;
  articleIds: string;
}

export const getJgateNextAISummary = async ({
  userQuery,
  articleIds,
}: GetAISummaryParams): Promise<string> => {
  const profileId = sessionStorage.getItem("user_id") || "";
  const customerId = sessionStorage.getItem("informaticscustomer_id") || "";

  try {
    const formData = new FormData();

    formData.append("profile_id", profileId);
    formData.append("customer_id", customerId);
    formData.append("user_query", userQuery);
    formData.append("article_ids", articleIds);

    const response = await fetch(`${api.baseApi}/api/get_jgatenext_insights/`, {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`API failed with status: ${response.status}`);
    }

    const data = await response.json();

    return data?.data?.summary || "";
  } catch (error) {
    console.error("Error fetching AI Summary:", error);

    // Re-throw so the calling component can decide what to do
    throw error;
  }
};

export const getJgateNextHistoryAISummary = async ({
  userQuery,
  articleIds,
}: GetAISummaryParams): Promise<string> => {
  const profileId = sessionStorage.getItem("user_id") || "";
  const customerId = sessionStorage.getItem("informaticscustomer_id") || "";

  try {
    const formData = new FormData();

    formData.append("profile_id", profileId);
    formData.append("customer_id", customerId);
    formData.append("user_query", userQuery);
    formData.append("article_ids", articleIds);

    const response = await fetch(
      `${api.baseApi}/api/get_jgatenext_insights_history/`,
      {
        method: "POST",
        body: formData,
      },
    );

    if (!response.ok) {
      throw new Error(`API failed with status: ${response.status}`);
    }

    const data = await response.json();

    return data?.data?.summary || "";
  } catch (error) {
    console.error("Error fetching AI Summary:", error);

    // Re-throw so the calling component can decide what to do
    throw error;
  }
};

export const removeSummaryHeading = (
  summary: string,
  heading = "Introduction",
): string => {
  if (!summary) return "";

  const regex = new RegExp(
    `<strong>${heading}:<\\/strong><br\\s*\\/?>\\s*`,
    "i",
  );

  return summary.replace(regex, "");
};
